import React from 'react';
import { Modal } from './ui/Modal';
import { CloudUpload, Loader } from 'lucide-react';

export default function PublishLocalWorkspaceModal({
  isOpen,
  onClose,
  workspace,
  onConfirm,
  loading = false,
}) {
  if (!isOpen || !workspace) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Publish to cloud"
      subtitle="Sync your local workspace to the cloud"
      customIcon={<CloudUpload size={22} className="text-blue-500" />}
      preventBackdropClose={loading}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="modal-header-subtitle" style={{ fontSize: '0.875rem' }}>
          Copy <strong className="modal-header-title" style={{ fontSize: '0.875rem', fontWeight: 600 }}>{workspace.name}</strong> from
          this device to your account. Collections, requests, variables, and environments will be
          uploaded to the server as a private workspace.
        </p>

        <button
          type="submit"
          disabled={loading}
          className="flex w-full items-center justify-center space-x-2 rounded-lg bg-blue-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {loading && <Loader className="animate-spin" size={16} />}
          <span>{loading ? 'Publishing…' : 'Publish to cloud'}</span>
        </button>
      </form>
    </Modal>
  );
}
